import { render } from "./SettingsPartnerPopper.vue?vue&type=template&id=145129ec&scoped=true"
import script from "./SettingsPartnerPopper.vue?vue&type=script&lang=js"
export * from "./SettingsPartnerPopper.vue?vue&type=script&lang=js"

import "./SettingsPartnerPopper.vue?vue&type=style&index=0&id=145129ec&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145129ec"]])

export default __exports__